import { render } from "./BAlert.vue?vue&type=template&id=61599faf"
import script from "./BAlert.vue?vue&type=script&lang=js"
export * from "./BAlert.vue?vue&type=script&lang=js"

import "./BAlert.vue?vue&type=style&index=0&id=61599faf&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__